"use client";

import { useEffect } from "react";

import markerSDK, { type MarkerSdk } from "@marker.io/browser";

// The Marker.io project id is not a secret — it ships in the client bundle either
// way — so it lives here rather than in the environment.
export const MARKERIO_PROJECT_ID = "6a7ea0eb138ea54c03da334c";

export function MarkerIO() {
  useEffect(() => {
    let widget: MarkerSdk | null = null;
    let unmounted = false;

    markerSDK
      .loadWidget({ project: MARKERIO_PROJECT_ID })
      .then((sdk) => {
        // React 19 StrictMode runs effects twice in dev; drop a widget that
        // resolved after the cleanup already ran.
        if (unmounted) {
          sdk.unload();
          return;
        }
        widget = sdk;
      })
      .catch((error) => {
        console.error("[MarkerIO] widget failed to load:", error);
      });

    return () => {
      unmounted = true;
      widget?.unload();
    };
  }, []);

  return null;
}

export default MarkerIO;
